import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/Main.vue";
import Home from "@/components/Home.vue";
import publicRoutes from "./public";
import {
  verifyToken,
  patientRouteGuard,
  trackPage,
  conditionalRoute,
} from "./navigation-guard";
import patientRoutes from "./patient";
import dashboardRoutes from "./dashboard";
import dashboardAlertsRoutes from "./followups";
import treatmentRoutes from "./treatment";
import userRoutes from "./user";
import profileRoutes from "./profile";
import indicationRoutes from "./indication";
import appointmentRoutes from "./appointment";
import settingsRoutes from "./settings";
import paymentRoutes from "./payment";
import validationRoutes from "./validation";
import prescriptionRoutes from "./prescription";
import contractsRoutes from "./contracts";
import administrationRoutes from "./administration";
import memberRoutes from "./members";
import providerRoutes from "./providers";
import claimRoutes from "./claims";
import planRoutes from "./plans";
import pharmacyRoutes from "./pharmacies";
import authorizationRoutes from "./authorization";
import auditRoutes from "./audit";
import platformRoutes from "./platform";
import reportsRoutes from "./reports";
import supportRoutes from "./support";
// UC-REG-160: Gestiones de trámites (paciente/prestador → admin del centro
// médico). Nuevas rutas: /my-procedures, /procedures, /procedure-types.
import procedureRoutes from "./procedure";
// UC-REG-162: CRM de órdenes — bandeja del operador comercial para
// trackear órdenes lab/imagen/prácticas emitidas y ofrecer turnos.
import ordersCrmRoutes from "./orders-crm";
// UC-REG-315: padrón de pacientes registrados (Campana).
import patientRegistryRoutes from "./patient-registry";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "is-active",
  routes: [
    ...publicRoutes,
    {
      path: "/",
      component: Main,
      children: [
        {
          path: "/",
          name: "home",
          component: Home,
        },
        ...dashboardAlertsRoutes,
        ...dashboardRoutes,
        ...patientRoutes,
        ...patientRegistryRoutes,
        ...treatmentRoutes,
        ...userRoutes,
        ...profileRoutes,
        ...indicationRoutes,
        ...appointmentRoutes,
        ...settingsRoutes,
        ...paymentRoutes,
        ...validationRoutes,
        ...prescriptionRoutes,
        ...procedureRoutes,
        ...ordersCrmRoutes,
        ...contractsRoutes,
        ...administrationRoutes,
        ...memberRoutes,
        ...providerRoutes,
        ...claimRoutes,
        ...planRoutes,
        ...pharmacyRoutes,
        ...authorizationRoutes,
        ...auditRoutes,
        ...platformRoutes,
        ...reportsRoutes,
        ...supportRoutes,
      ],
    },
  ],
});

router.beforeEach(verifyToken);
router.beforeEach(patientRouteGuard);
router.beforeEach(trackPage);
router.beforeEach(conditionalRoute);

export default router;
